// extracted by mini-css-extract-plugin
export default {"icon-wrapper":"styles_icon-wrapper__KBMh2"};